import C from 'cesium';

import * as layerOps from '../../api/Layers/layer-operations';

import adaptURL from '../adapt-url';

/**
 * Builds the WMS provider for the viewer.
 *
 * @param {object} layer - The layer object.
 * @param {object[]} alpha - The transparency value.
 * @returns {object} The cesium provider to add to the viewer.
 */
const buildWMSLayer = (layer, alpha) => {
  const imageryProvider = new C.WebMapServiceImageryProvider({
    url: adaptURL(layerOps.getURL(layer)),
    layers: layerOps.getWMSLayerNames(layer),
    parameters: {
      format: 'image/png',
      version: layerOps.getWMSVersion(layer)
    },
    styles: layerOps.getWMSLayerStyle(layer),
    credit: layerOps.getAttribution(layer)
  });
  return new C.ImageryLayer(imageryProvider, { alpha });
};

export default buildWMSLayer;
